const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const API_ENDPOINTS = {
  STORE_URL: `${API_BASE_URL}/store_url`,
  DELETE_POSITION: `${API_BASE_URL}/delete_position`,
  DELETE_SEARCH_ENTRY: `${API_BASE_URL}/delete_search_entry`,
  GET_STORED_URLS: `${API_BASE_URL}/get_stored_urls`,
  SEARCH: `${API_BASE_URL}/search`,
  UPDATE_FREQUENCY: `${API_BASE_URL}/update_frequency`,
  UPDATE_TRACKING: `${API_BASE_URL}/update_tracking`,
  MARK_RESULT: `${API_BASE_URL}/mark_result`,
  SET_MAX_SEARCHES: `${API_BASE_URL}/set_max_searches`,
  SET_PLAN_TYPE: `${API_BASE_URL}/set_plan_type`,
  GET_USER_INFO: `${API_BASE_URL}/get_user_info`,
  REGISTER_USER: `${API_BASE_URL}/register_user`,
  LIST_USERS: `${API_BASE_URL}/list_users`,
  UPDATE_USER_PROFILE: `${API_BASE_URL}/update_user_profile`,
  GET_USER_PROFILE: `${API_BASE_URL}/get_user_profile`,
  
  UPLOAD_RESUME: `${API_BASE_URL}/upload_resume`,
  GET_RESUME_METADATA: `${API_BASE_URL}/get_resume_metadata`,
  DOWNLOAD_RESUME: `${API_BASE_URL}/download_resume`,
  DELETE_RESUME: `${API_BASE_URL}/delete_resume`,
  
  GET_REFERRAL_CODE: `${API_BASE_URL}/get_referral_code`,           // GET ?user_id=xxx
  SEND_REFERRAL_INVITE: `${API_BASE_URL}/send_referral_invite`,     // POST
  GET_REFERRAL_STATS: `${API_BASE_URL}/get_referral_stats`,         // GET ?user_id=xxx
  GET_REFERRAL_HISTORY: `${API_BASE_URL}/get_referral_history`,     // GET ?user_id=xxx
  VALIDATE_REFERRAL_CODE: `${API_BASE_URL}/validate_referral_code`, // GET ?referral_code=xxx
  APPLY_REFERRAL: `${API_BASE_URL}/apply_referral`,                 // POST
};

export default API_BASE_URL;